import { render, staticRenderFns } from "./CampCoupons.vue?vue&type=template&id=be5430f8&"
import script from "./CampCoupons.vue?vue&type=script&lang=js&"
export * from "./CampCoupons.vue?vue&type=script&lang=js&"
import style0 from "./CampCoupons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports